import Seta from '@assets/images/Seta.svg';
import PlaceholderImage from '@assets/images/img-final-home-01.png';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import {
  SectionWrapper,
  StyledHr,
  ContentWrapper,
  TextBox1,
  TextBox2,
  ImageBox,
  SectionContainer,
} from './SectionOne.style';

const SectionOne = () => {
  const { t } = useTranslation('home');
  return (
    <SectionContainer>
      <SectionWrapper>
        <h1>{t('sectionOne.title')}</h1>
        <StyledHr />
      </SectionWrapper>

      <ContentWrapper>
        <TextBox1>
          <div className="text-content">
            <p>
              C<span>2</span>
              {t('sectionOne.paragraphOne')}
            </p>
          </div>
        </TextBox1>
        <ImageBox>
          <img src={PlaceholderImage} alt="Imagem" />
        </ImageBox>
        <TextBox2>
          <p>{t('sectionOne.paragraphTwo')}</p>
          <Link to="/audit" className="link-with-icon">
            {t('sectionOne.link')}
            <div>
              <img src={Seta} alt="Saiba Mais" />
            </div>
          </Link>
        </TextBox2>
      </ContentWrapper>
    </SectionContainer>
  );
};

export default SectionOne;
